import React, { useState, useMemo } from 'react';
import { Star, MapPin } from 'lucide-react';
import { getStayAmenityDisplayLines } from '../utils/listingAttributesDisplay';
import FoundersVerifiedBadge from './FoundersVerifiedBadge';
import { getVisibleDotIndices } from '../utils/carouselDots';
import ResponsiveImage from './ResponsiveImage';
import {
  getStayBookableMinPrice,
  isStayComingSoon
} from '../utils/stayComingSoon';

const PawButtonIcon = ({ className = '' }) => (
  <svg className='absolute right-[10%] bottom-[-5%]' xmlns="http://www.w3.org/2000/svg" width="24" height="26" viewBox="0 0 28 32" fill="none">
  <path d="M17.8311 9.07719C17.4572 9.07719 17.076 8.98554 16.7388 8.90489C15.8407 8.68863 13.7404 8.18645 14.2425 6.0861C14.4368 5.27235 14.8803 4.56307 15.4907 4.08838C16.1395 3.58254 16.9293 3.39377 17.6643 3.56972C19.1342 3.92161 19.9919 5.62424 19.5759 7.36353C19.246 8.74177 18.5495 9.07719 17.8311 9.07719ZM17.1127 4.97179C16.7974 4.97179 16.5335 5.1349 16.3905 5.2467C16.0478 5.51428 15.7839 5.94498 15.6684 6.42883C15.5621 6.87052 15.5768 7.11977 17.0796 7.479C17.3142 7.53581 17.8073 7.65129 17.9191 7.60547C17.9191 7.60547 18.0309 7.51565 18.1482 7.02264C18.3718 6.0861 17.9942 5.15873 17.3216 4.99745C17.2501 4.98095 17.1805 4.97179 17.1127 4.97179Z" fill="#808080"/>
  <path d="M9.68556 8.23943C9.35016 8.23943 9.01292 8.19179 8.70501 8.03967C8.12952 7.75375 7.79595 7.18926 7.68782 6.3187C7.58885 5.52144 7.74829 4.73336 8.13684 4.09922C8.55287 3.42293 9.20351 2.98305 9.92562 2.89508C10.6422 2.80527 11.3845 3.07104 11.9545 3.62454C12.4878 4.14321 12.8342 4.86897 12.9332 5.66622C13.0707 6.76588 12.5685 7.35605 12.1213 7.65662C11.6173 7.99752 10.9685 8.1148 10.3985 8.18627C10.1694 8.2156 9.92748 8.23943 9.68189 8.23943H9.68556ZM10.2079 4.34113C10.1749 4.34113 10.1419 4.34297 10.1071 4.34847C9.72768 4.39613 9.49126 4.69302 9.38679 4.8653C9.17419 5.2117 9.08621 5.67356 9.14302 6.13542C9.18334 6.45799 9.26402 6.67791 9.35749 6.72556C9.5371 6.81537 10.0338 6.75306 10.2207 6.72923C10.5946 6.68341 11.0546 6.60828 11.302 6.43967C11.3882 6.38102 11.5348 6.28205 11.4798 5.84402C11.423 5.38216 11.2232 4.95329 10.9318 4.67104C10.7998 4.54275 10.5396 4.3393 10.2079 4.3393V4.34113Z" fill="#808080"/>
  <path d="M4.47404 12.411C3.61997 12.411 3.127 11.8703 2.90706 11.5441C2.08782 10.3234 2.36087 8.69777 3.51734 7.92068C4.67382 7.14542 6.283 7.50465 7.10408 8.72527C7.52378 9.35024 7.63008 9.94955 7.42298 10.5085C7.21221 11.0785 6.72286 11.4616 6.31965 11.7328C5.57371 12.2332 4.96522 12.411 4.47404 12.411ZM4.87729 8.97452C4.68668 8.97452 4.49787 9.02767 4.33475 9.13581C3.84907 9.46204 3.75378 10.175 4.124 10.7248C4.22297 10.8733 4.45757 11.216 5.50224 10.514C5.91278 10.2391 6.02091 10.0723 6.0484 9.9972C6.09056 9.88173 5.98428 9.68563 5.88714 9.54084C5.64155 9.17612 5.253 8.97269 4.87729 8.97269V8.97452Z" fill="#808080"/>
  <path d="M22.6024 13.142C21.9059 13.142 21.2864 12.726 20.8979 12.4657C20.2729 12.0442 18.3668 10.7649 19.6827 8.80751C20.7182 7.26616 22.6188 6.72183 23.9183 7.59606C25.2177 8.47028 25.434 10.4332 24.3985 11.9745C23.8047 12.8598 23.1779 13.142 22.6024 13.142ZM22.5107 8.64075C21.9536 8.64075 21.3139 9.00546 20.8997 9.62311C20.59 10.085 20.491 10.424 21.7153 11.2469C22.6225 11.8554 22.7453 11.8059 23.1815 11.1553C23.757 10.2994 23.7185 9.22539 23.1009 8.81118C22.9286 8.69572 22.7252 8.64075 22.5107 8.64075Z" fill="#808080"/>
  <path d="M22.7728 42.6478H4.44512C4.24351 42.6478 4.05109 42.5653 3.9118 42.4187C3.77434 42.2721 3.70102 42.0742 3.71201 41.8744C3.71934 41.7424 4.44328 28.6327 4.44328 22.854C4.44328 18.9942 3.8055 16.4668 3.36747 15.1838C2.50607 14.6817 1.7473 13.9614 1.16082 13.089C-0.642625 10.404 -0.307261 7.00971 1.90672 5.5215C2.92024 4.84155 4.20502 4.65826 5.48979 4.98266C5.75004 2.43695 7.38671 0.446562 9.5842 0.171647C11.2777 -0.0409534 12.9088 0.809457 13.9828 2.3783C15.198 1.17601 16.7686 0.660999 18.2715 1.02205C20.0181 1.44176 21.3157 2.98312 21.6915 4.99C22.9909 4.6436 24.2702 4.82689 25.3075 5.52334C27.5215 7.01154 27.8568 10.4058 26.0534 13.0908C25.4669 13.965 24.7082 14.6835 23.8468 15.1857C23.4069 16.4668 22.7691 18.9923 22.7691 22.8558C22.7691 28.6327 23.493 41.7443 23.5004 41.8762C23.5114 42.0778 23.4399 42.2739 23.3006 42.4206C23.1613 42.5672 22.9689 42.6497 22.7673 42.6497L22.7728 42.6478ZM5.21854 41.1816H21.9975C21.8417 38.2638 21.3047 27.8519 21.3047 22.854C21.3047 18.4901 22.0928 15.6988 22.562 14.4232C22.6243 14.2528 22.749 14.1117 22.9121 14.0274C23.6635 13.6352 24.3288 13.0285 24.8383 12.2716C26.1909 10.2592 26.0351 7.77581 24.4919 6.7403C23.6415 6.17031 22.5052 6.13913 21.3726 6.65781C21.1508 6.76044 20.8924 6.74395 20.6816 6.61566C20.4708 6.48736 20.3425 6.26193 20.3334 6.01817C20.2674 4.21107 19.3015 2.77602 17.9288 2.44795C16.7063 2.15471 15.3757 2.77785 14.4612 4.07728C14.3109 4.28988 14.0616 4.409 13.7941 4.38517C13.532 4.36135 13.3047 4.19824 13.1947 3.95998C12.4671 2.37464 11.1237 1.46009 9.76381 1.62688C8.06483 1.83948 6.81672 3.74922 6.92486 5.97786C6.93768 6.23445 6.81305 6.47821 6.60045 6.623C6.38602 6.76595 6.11112 6.7861 5.88019 6.67613C4.73654 6.13913 3.5874 6.16114 2.72234 6.7403C1.17915 7.77764 1.02334 10.2592 2.37592 12.2716C2.88543 13.0285 3.55072 13.637 4.30216 14.0274C4.46344 14.1117 4.58805 14.2528 4.6522 14.4251C5.12139 15.7007 5.9095 18.4938 5.9095 22.854C5.9095 27.8519 5.37249 38.2638 5.21671 41.1816H5.21854Z" fill="#808080"/>
  <path d="M16.1752 19.9214C15.3541 19.9214 14.9986 19.7217 14.6485 19.4798C14.4304 19.3295 14.2251 19.1883 13.2428 19.1883C12.2604 19.1883 12.0552 19.3295 11.8371 19.4798C11.487 19.7217 11.1314 19.9214 10.3104 19.9214C9.295 19.9214 7.37793 19.0014 7.37793 15.5228C7.37793 12.2733 10.5871 9.65796 13.2428 9.65796C15.8985 9.65796 19.1076 12.2733 19.1076 15.5228C19.1076 19.0014 17.1906 19.9214 16.1752 19.9214ZM13.2428 17.7221C14.5734 17.7221 15.0444 17.9714 15.4806 18.2738C15.6602 18.3984 15.7427 18.4552 16.1752 18.4552C16.5839 18.4552 17.6414 17.9274 17.6414 15.5228C17.6414 12.9716 15.0132 11.1242 13.2428 11.1242C11.4723 11.1242 8.84414 12.9716 8.84414 15.5228C8.84414 17.9274 9.90165 18.4552 10.3104 18.4552C10.7411 18.4552 10.8235 18.3984 11.005 18.2738C11.443 17.9732 11.9122 17.7221 13.2428 17.7221Z" fill="#808080"/>
</svg>
);
 
const SearchStayCard = ({ stay, onStayClick, searchFilters, layout = 'grid' }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isLiked, setIsLiked] = useState(false);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  // Get images or use fallback
  const images = stay.images && stay.images.length > 0 ? stay.images : [
    'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800'
  ];

  // Minimum swipe distance (in px)
  const minSwipeDistance = 50;

  // Handle touch start
  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  // Handle touch move
  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  // Handle touch end
  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) {
      // Swipe left - next image
      setCurrentImageIndex((prev) => 
        prev === images.length - 1 ? 0 : prev + 1
      );
    } else if (isRightSwipe) {
      // Swipe right - previous image
      setCurrentImageIndex((prev) => 
        prev === 0 ? images.length - 1 : prev - 1
      );
    }
  };

  // Handle image dots click
  const selectImage = (index, e) => {
    e.stopPropagation();
    setCurrentImageIndex(index);
  };

  // Handle like toggle
  const toggleLike = (e) => {
    e.stopPropagation();
    setIsLiked(!isLiked);
  };

  const stayComingSoon = isStayComingSoon(stay);
  const minPrice = stayComingSoon ? null : getStayBookableMinPrice(stay);

  const amenityTags = useMemo(() => {
    const lines = getStayAmenityDisplayLines(stay);
    if (lines.length > 0) return lines.slice(0, 8);
    if (stay.features && Array.isArray(stay.features)) {
      return stay.features.map((f) => f.title).filter(Boolean).slice(0, 6);
    }
    return [];
  }, [stay]);

  // Handle card click
  const handleCardClick = () => {
    onStayClick(stay.stayId);
  };

  // Handle book now click
  const handleBookNow = (e) => {
    e.stopPropagation();
    onStayClick(stay.stayId);
  };

  const isList = layout === 'list';

  return (
    <div 
      className={`cursor-pointer overflow-hidden bg-white flex justify-between shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-shadow duration-300 group hover:shadow-[0_4px_16px_rgba(0,0,0,0.08)] ${
        isList
          ? 'flex flex-row rounded-[16px] border border-[#ececec]'
          : 'rounded-[16px] border border-[#ececec] flex-col'
      }`}
      onClick={handleCardClick}
    >
      {/* Image Gallery */}
      <div className={`relative ${isList ? 'w-[38%] min-w-[200px] shrink-0 overflow-hidden' : ''}`}>
        <div
          className={`relative overflow-hidden ${isList ? 'aspect-[5/4] h-full' : ' md:min-h-[300px] flex items-center justify-center aspect-[4/3] w-full'}`}
          onTouchStart={onTouchStart}
          onTouchMove={onTouchMove}
          onTouchEnd={onTouchEnd}
        >
           {/* Gradient Overlays */}
           <div className='h-[46px] absolute z-10 top-0 left-0 w-full '
          style={{
            background: 'linear-gradient(360deg,rgb(121, 121, 121, 0) 0%,rgb(19, 19, 19, 0.33) 100%)',
            backdropFilter: 'blur(8px)',
            mask: 'linear-gradient(0deg, rgba(0, 0, 0, 0.00) 0%, rgba(255, 255, 255) 100%)',
          }}
          ></div>
          <div className="relative h-full md:min-h-[300px] w-full flex items-center justify-center">
            <ResponsiveImage
              key={currentImageIndex}
              src={images[currentImageIndex]}
              variant="card"
              sizes={
                isList
                  ? '(max-width: 768px) 38vw, min(360px, 40vw)'
                  : undefined
              }
              alt={`${stay.title} ${currentImageIndex + 1}`}
              className="h-full w-full object-cover"
              onError={(e) => {
                const fallback = 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800';
                if (e.target.src !== fallback) {
                  e.target.src = fallback;
                }
              }}
            />
          </div>
          
          {/* Gradient Overlays */}
          <div className='h-[46px] absolute bottom-0 left-0 w-full'
            style={{
              background: 'linear-gradient(178deg,rgba(121, 121, 121, 0) 0%,rgba(19, 19, 19, 0.33) 100%)',
              backdropFilter: 'blur(8px)',
              mask: 'linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(255, 255, 255) 100%)',
            }}
          ></div>

          {/* Heart icon */}
          {/* <button
            onClick={toggleLike}
            className="absolute top-3 right-3 p-2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full shadow-md transition-all duration-200 z-10"
          >
            <Heart 
              size={16} 
              className={`transition-colors duration-200 ${
                isLiked ? 'text-red-500 fill-current' : 'text-gray-700'
              }`} 
            />
          </button> */}

          {/* Image Indicators - only show if multiple images */}
          {images.length > 1 && (
            <div
              className={`absolute bottom-3 z-10 flex items-center space-x-[6px] right-4`}
            >
              {getVisibleDotIndices(images.length, currentImageIndex).map((index) => (
                <button
                  key={index}
                  type="button"
                  aria-label={`Image ${index + 1}`}
                  onClick={(e) => selectImage(index, e)}
                  className={`bg-white rounded-full transition-all duration-200 ${
                    index === currentImageIndex ? 'w-[14px] h-[14px]' : 'w-[6.5px] h-[6.5px]'
                  }`}
                />
              ))}
            </div>
          )}
          <div className="absolute left-[8px] top-[8px] z-20 flex max-w-[calc(100%-16px)] flex-wrap items-center gap-[6px]">
          {stay.rating && (
            <div
              className={`z-20 flex items-stretch overflow-hidden shadow-sm ${
                isList ? 'rounded-full bg-black/90 px-3 py-1.5' : 'rounded-full'
              }`}
            >
              {isList ? (
                <span className="text-[12px] font-medium leading-none text-white md:text-[13px]">
                  {stay.rating} {stay.ratingTag || 'Excellent'}
                </span>
              ) : (
                <>
                  <span className="flex min-h-[32px] min-w-[36px] items-center justify-center bg-black px-2 text-[12px] font-semibold leading-none text-white">
                    {stay.rating}
                  </span>
                  <span className="flex items-center bg-white px-2.5 text-[11px] font-semibold leading-none text-black">
                    {stay.ratingTag || 'Excellent'}
                  </span>
                </>
              )}
            </div>
          )}

          {/* Founder verified badge */}
          {stay.founderVerified && (
            <FoundersVerifiedBadge size="sm" className="z-20" />
          )}
          </div>
        </div>
      </div>

      {/* Content */}
      <div className={`flex min-w-0 flex-1 flex-col p-3 md:p-4  h-full justify-between ${isList ? 'justify-between' : 'bg-white'}`}>
       
          <div>
        {/* Title */}
        <h3 className="font-medium md:font-semibold text-black text-[18px] md:text-[17px] mb-[10px] md:mb-2 leading-snug md:leading-tight">
          {stay.title}
        </h3>

        {/* Address */}
        <p className="text-[12px] md:text-[13px] text-[#bebebe] md:text-[#9ca3af] leading-relaxed md:mb-3">
          {stay.address || `${stay.city}, ${stay.state}`}
        </p>
        </div>

        <div className='flex  items-center justify-center my-[12px]'>
                  <svg width="100%" height="1px">
                    <line 
                      x1="0" y1="1" x2="100%" y2="1" 
                      stroke="#f0f0f0" 
                      strokeWidth="2" 
                      strokeDasharray="10 4"
                    />
                  </svg>
          </div>
      
        {/* Price and Book button */}
        <div className="flex items-center justify-between gap-3 mt-auto md:mt-0">
          <div className="flex flex-col min-w-0">
            {stayComingSoon ? (
              <span className="text-[14px] md:text-[15px] font-medium text-[#78736A] leading-[1.1]">
                Coming soon
              </span>
            ) : minPrice ? (
              <span className="text-[14px] md:text-[15px] font-medium text-black leading-[1.1]">
                ₹{minPrice.toLocaleString('en-IN')} onwards
              </span>
            ) : (
              <span className="text-sm text-gray-600">Contact for pricing</span>
            )}
          </div>
          
          <button
            onClick={handleBookNow}
            disabled={stayComingSoon || stay.canAccommodateRequest === false}
            className="flex h-[44px] relative overflow-hidden w-[min(100%,168px)] shrink-0 items-center justify-center gap-2 rounded-[8px] bg-black px-4 text-[14px] font-semibold text-white shadow-sm transition-colors hover:bg-neutral-800 disabled:cursor-not-allowed disabled:bg-gray-400 md:h-[48px] md:min-w-[180px] md:max-w-[220px] md:justify-center md:px-5 md:text-[15px]"
          >
            <span className="tracking-wide">
              {stayComingSoon
                ? 'COMING SOON'
                : stay.canAccommodateRequest === false
                  ? 'UNAVAILABLE'
                  : 'BOOK STAY'}
            </span>
            <PawButtonIcon />
          </button>
        </div>

      </div>
    </div>
  );
};

export default SearchStayCard;
